import React, { createContext, useState, useContext, useEffect } from "react";
import { useStableCallbacks } from "../utils/useStableCallbacks";
import { axiosInstance } from "../axios/axiosInstance";
import { useLocation } from "react-router-dom";
import JSEncrypt from "jsencrypt";
import axios from "axios";
import { clearLoginReturnUrl, getLoginReturnUrl } from "../Layout/Common/common";

// Create Auth Context
const AuthContext = createContext(null);

// Provide Auth Context
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setAthuLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(null); // Add loading state
  const location = useLocation();
  useEffect(() => {
    setAthuLoading(true);
    authenticate(true);
  }, []);

  const authenticate = (firstRender = false) => {
    const data = {
      LoginName: "",
      token: "",
    };

    if (firstRender) setAthuLoading(true);
    axiosInstance
      .post("Authentication", data)
      .then((response) => {
        if (response.data && response.status === 200) {
          const responseData = response.data.data;
          setUser(responseData);
          setAthuLoading(false);
          setIsAuthenticated(true);
          if (firstRender) {
            if (String(location.pathname).toLowerCase().includes("/login")) {
              const returnUrl = getLoginReturnUrl();
              clearLoginReturnUrl();
              window.location.href = returnUrl || "/home";
            } else {
              clearLoginReturnUrl();
            }
          }
        } else {
          setUser(null);
          setAthuLoading(false);
          setIsAuthenticated(false);
        }
      })
      .catch((error) => {
        setIsAuthenticated(false);
        setAthuLoading(false);
        setUser(null);
      });
  };

  const checkAuthentication = async () => {
    try {
      const data = {
        LoginName: "",
        token: "",
      };

      var response = await axios.post(window.location.origin + "/api/Authentication", data);
      if (response.data && response.status === 200) {
        const responseData = response.data.data;
        localStorage.setItem("authToken", responseData?.token);
        sessionStorage.setItem("authToken", responseData?.token);
        setUser(responseData);
        setAthuLoading(false);
        setIsAuthenticated(true);
        return response;
      } else {
        setUser(null);
        setAthuLoading(false);
        setIsAuthenticated(false);
        return null;
      }
    } catch (e) {
      setUser(null);
      setAthuLoading(false);
      setIsAuthenticated(false);
      return null;
    }
  };

  const postAuthentication = async () => {
    try {
      const data = {
        LoginName: "",
        token: "",
      };

      var response = await axios.post(window.location.origin + "/api/Authentication", data);
      if (response.data && response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  };
  const loginfunction = async ({ params }) => {
    try {
      setAthuLoading(true);
      const response = await axios.post(window.location.origin + "/api/Authenticate/CheckLogin", params);
      setAthuLoading(false);
      if (response.data) {
      } else {
      }
    } catch (e) {
      console.error(e);
    }
  };

  function encryptPrivateToken(data) {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(process.env.REACT_APP_REACT_APP_PRVT_KEY);
    return encryptor.encrypt(JSON.stringify(data));
  }
  const contextValue = useStableCallbacks({
    authLoading: loading,
    user,
    userId: user?.userId,
    userName: user?.userName,
    loginName: user?.loginName,
    emailAddress: user?.emailAddress,
    token: user?.token,
    role: user?.userRole,
    isBrowseOnly: user?.userRole === "4" ? true : false,
    companyId: user?.companyId,
    priceCode: user?.priceCode,
    authenticate,
    checkAuthentication,
    postAuthentication,
    isAuthenticated: isAuthenticated,
    setUser,
    setAthuLoading,
    encryptPrivateToken,
    sessionTime: 1,
    loginfunction,
    eBayBlock: user?.eBayBlock,
    phoneNumber: user?.phoneNumber,
    showWelcomepopup: user?.showWelcomepopup,
    showPreviousOrderPopup: user?.showPreviousOrderPopup !== false,
  });

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
